import { useState, useCallback } from "react";

interface UseOrderAgreementsReturn {
  cancelRuleAgree: boolean;
  purchaseAllAgree: boolean;
  purchaseOneAgree: boolean;
  setCancelRuleAgree: (v: boolean) => void;
  togglePurchaseAgreeOptions: (v: boolean) => void;
  allAgreed: boolean;
}

/**
 * 결제 동의 체크박스 상태를 관리합니다.
 */
export function useOrderAgreements(): UseOrderAgreementsReturn {
  const [cancelRuleAgree, setCancelRuleAgree] = useState(false);
  const [purchaseAllAgree, setPurchaseAllAgree] = useState(false);
  const [purchaseOneAgree, setPurchaseOneAgree] = useState(false);

  const togglePurchaseAgreeOptions = useCallback((agree: boolean) => {
    setPurchaseAllAgree(agree);
    setPurchaseOneAgree(agree);
  }, []);

  const allAgreed = cancelRuleAgree && purchaseAllAgree;

  return {
    cancelRuleAgree,
    purchaseAllAgree,
    purchaseOneAgree,
    setCancelRuleAgree,
    togglePurchaseAgreeOptions,
    allAgreed,
  };
}
